// CombinedPDF.jsx
import React from "react";
import { Document } from "@react-pdf/renderer";

import PresupuestoPDF from "./PresupuestoPDF";
import CondicionesEnfermeria from "./CondicionesEnfermeria";
import CondicionesCuidador from "./CondicionesCuidador";

export default function CombinedPDF(props) {
  const { tipo } = props;

  // Enfermería → Presupuesto + Condiciones Enfermería
  if (tipo === "enfermeria") {
    return (
      <CondicionesEnfermeria {...props} />
    );
  }

  // Cuidador → Presupuesto + Condiciones Cuidador
  if (tipo === "cuidador") {
    return (
      <CondicionesCuidador {...props} />
    );
  }

  // Solo presupuesto
  return (
    <Document>
      <PresupuestoPDF {...props} />
    </Document>
  );
}
